import { motion } from 'framer-motion';
import { Mic, Square } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AnimatedRecordButtonProps {
  onRecordComplete?: (blob: Blob) => void;
  isRecording?: boolean;
  onStartRecording?: () => void;
  onStopRecording?: () => void;
  className?: string;
}

export const AnimatedRecordButton = ({
  isRecording = false,
  onStartRecording,
  onStopRecording,
  className,
}: AnimatedRecordButtonProps) => {
  const handleClick = () => {
    if (isRecording) {
      onStopRecording?.();
    } else {
      onStartRecording?.();
    }
  };

  return (
    <motion.button
      onClick={handleClick}
      whileTap={{ scale: 0.9 }}
      className={cn(
        'relative w-16 h-16 rounded-full shadow-lg flex items-center justify-center',
        'transition-colors duration-300',
        isRecording ? 'bg-destructive' : 'bg-primary',
        className
      )}
    >
      {/* Pulse rings when recording */}
      {isRecording && (
        <>
          <motion.div
            initial={{ scale: 1, opacity: 0.5 }}
            animate={{ scale: 2, opacity: 0 }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="absolute inset-0 rounded-full bg-destructive"
          />
          <motion.div
            initial={{ scale: 1, opacity: 0.5 }}
            animate={{ scale: 2, opacity: 0 }}
            transition={{ duration: 1.5, repeat: Infinity, delay: 0.5 }}
            className="absolute inset-0 rounded-full bg-destructive"
          />
        </>
      )}

      {/* Icon */}
      <motion.div
        animate={isRecording ? { scale: [1, 1.1, 1] } : {}}
        transition={{ duration: 0.5, repeat: isRecording ? Infinity : 0 }}
        className="relative z-10"
      >
        {isRecording ? (
          <Square className="w-6 h-6 text-white fill-white" />
        ) : (
          <Mic className="w-7 h-7 text-primary-foreground" />
        )}
      </motion.div>
    </motion.button>
  );
};
